import ToastConfig from './toast.vue'

const createToastContructor = function (Vue, Config) {
  const ToastContructor = Vue.extend(Config)

  ToastContructor.prototype.close = function () {
    this.visible = false
    this.$el.addEventListener('transitionend', this.destroyeInstance.bind(this))
  }
  // 销毁实例
  ToastContructor.prototype.destroyeInstance = function () {
    this.$destroy(true)
    this.$el.removeEventListener('transitionend', this.destroyeInstance)
    this.$el.parentNode.removeChild(this.$el)
  }
  return ToastContructor
}

// 强制销毁所有实例
const destroyAllInstance = (list) => {
  while (list.length) {
    const $currentInstance = list.pop()
    $currentInstance.destroyeInstance()
  }
}

export default {
  install(Vue, options) {
    const ToastContructor = createToastContructor(Vue, ToastConfig)
    const defaultParams = {
      duration: 3000
    }
    const queue = []
    // 执行销毁
    Vue.prototype.$showToast = (params) => {
      // 强制销毁所有实例
      destroyAllInstance(queue)

      // 如果传入的是字符串 转换成json
      params = typeof params === 'string' ? {
        message: params
      } : params
      // 合并默认参数
      params = { ...defaultParams, ...params }
      const $instance = new ToastContructor({
        el: document.createElement('div'),
        propsData: params
      })
      queue.push($instance)
      document.body.appendChild($instance.$el)
      Vue.nextTick(() => {
        $instance.visible = true
        params.duration !== 0 && setTimeout(() => {
          $instance.close()
        }, params.duration)
      })
      return $instance
    }
  }
}
